import { render, staticRenderFns } from "./BaseSelectNestedParent.vue?vue&type=template&id=b90976ac&"
import script from "./BaseSelectNestedParent.vue?vue&type=script&lang=js&"
export * from "./BaseSelectNestedParent.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelectNestedParent.vue?vue&type=style&index=0&nested=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports